import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
}), ___EmotionJSX("polyline", {
  points: "14 2 14 8 20 8"
}), ___EmotionJSX("line", {
  x1: "16",
  y1: "13",
  x2: "8",
  y2: "13"
}), ___EmotionJSX("line", {
  x1: "16",
  y1: "17",
  x2: "8",
  y2: "17"
}), ___EmotionJSX("polyline", {
  points: "10 9 9 9 8 9"
}));
export default SVG;